import React, { Children, cloneElement } from 'react';

import * as S from './CombinedInputs.styles';

const CombinedInputs = ({ children: childrenProp, ...rest }) => {
  const children = Children.toArray(childrenProp);
  const total = children.length;

  return (
    <S.Container {...rest} total={total}>
      {children.map((child, index) => {
        return cloneElement(child, { key: `combined-inputs-child-${index}` });
      })}
    </S.Container>
  );
};

export { CombinedInputs };
